// extracted by mini-css-extract-plugin
export var falconContainer = "_vv-2";
export var offerCenter = "_vv-0";
export var roktContainer = "_vv-1";